// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"25":"1dd4a6c115fbb4e9","381":"1cd4be51a511d69b"}[chunkId] + ".js";
};